import { ChartTypes } from "models/enums/ChartType";
import { IChartData, ITimelineChartData } from "models/IChartData";
import { CustomBarChart } from "./BarChart";
import { CustomDonutChart } from "./DonutChart";
import { CustomLineChart } from "./LineChart";
import { CustomTimelineChart } from "./TimelineChart";

export const ChartWrapper = ({ chartData }: { chartData: IChartData }) => {
    const { chart_type } = chartData;

    switch (chart_type) {
        case ChartTypes.Line:
            return <CustomLineChart chartData={chartData} />;
        case ChartTypes.Bar:
            return <CustomBarChart chartData={chartData} />;
        case ChartTypes.Donut:
            return <CustomDonutChart chartData={chartData} />;
        case ChartTypes.Timeline:
            return <CustomTimelineChart chartData={chartData as ITimelineChartData} />;
        default:
            return <p>Unsupported chart type.</p>;
    }
};